import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Box, Flex } from 'reflexbox';

import { useFeature } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import {
	Card,
	ComposeIcon,
	DialogueIcon,
	DocumentIcon,
	FlexGap,
	Heading3,
	Modal,
	Separator,
	SuitcaseIcon,
	TargetIcon,
	tokens,
} from '@treams/treams-ui';

import FeedbackRequestProgress from './FeedbackRequestProgress';

function MethodCard(props: { icon: ReactNode; title: string; onClick: () => void }) {
	return (
		<Card onClick={props.onClick} chevron>
			<Flex alignItems="center" style={{ gap: tokens.gap.group }}>
				<Box flexShrink={0} color={tokens.icon.primary}>
					{props.icon}
				</Box>
				<Heading3>{props.title}</Heading3>
			</Flex>
		</Card>
	);
}

export default function FeedbackRequestModalMethod(props: {
	returnURL: string;
	onChange: (method: 'custom' | 'template' | 'goals' | 'competencies') => void;
}) {
	const history = useHistory();

	const { t } = useTranslation();

	const hasGoals = useFeature(graphql.FeatureName.Goals);
	const hasFeedbackGoals = useFeature(graphql.FeatureName.FeedbackGoals);
	const hasFeedbackCompetencies = useFeature(graphql.FeatureName.FeedbackCompetencies);

	return (
		<Modal>
			<Modal.Header
				icon={<DialogueIcon size={24} />}
				title={t('common.feedback.create')}
				closeLink={props.returnURL}
			/>

			<FeedbackRequestProgress step={0} />
			<Modal.Contents pt={0}>
				<FlexGap flexDirection="column" gap={tokens.gap.list}>
					<MethodCard
						icon={<DocumentIcon />}
						title={t('feedback.create.method.template')}
						onClick={() => props.onChange('template')}
					/>
					{hasGoals && hasFeedbackGoals && (
						<MethodCard
							icon={<TargetIcon />}
							title={t('feedback.create.method.goals')}
							onClick={() => props.onChange('goals')}
						/>
					)}
					{hasFeedbackCompetencies && (
						<MethodCard
							icon={<SuitcaseIcon />}
							title={t('feedback.create.method.competencies')}
							onClick={() => props.onChange('competencies')}
						/>
					)}
					<Separator />
					<MethodCard
						icon={<ComposeIcon />}
						title={t('feedback.create.method.plain')}
						onClick={() => props.onChange('custom')}
					/>
				</FlexGap>
			</Modal.Contents>

			<Modal.FormFooter onCancel={() => history.push(props.returnURL)} disabled />
		</Modal>
	);
}
